import { IoIosSearch } from "react-icons/io";
import { IoIosPin } from "react-icons/io";
import { useState } from "react";

const SearchBar = (props) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className="flex py-8 w-full gap-2">
            <div className="flex border-gray-300 shadow-lg rounded-full w-full justify-between bg-white text-black">
                <input
                    placeholder="Search Location"
                    onChange={props.onChange}
                    onKeyDownCapture={props.search}
                    className="p-2 pl-4 rounded-full outline-none w-full"
                    value={props.value}
                ></input>
                <div className="grid place-content-center pr-5">
                    <IoIosSearch className="text-xl" />
                </div>
            </div>

            <div
                className="p-2 grid place-content-center shadow-lg hover:scale-110 ease-in-out duration-300 rounded-full bg-white relative"
                onClick={props.onClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <IoIosPin className="text-2xl text-black" />
                {isHovered && (

                    <div>
                        <div className="w-[120px] absolute right-0 top-12 bg-black p-2 rounded text-xs text-white grid place-content-center">
                            check my location
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchBar;
